export default __webpack_public_path__ + "static/media/001-ant.1bce00c9.svg";